import type { CSSProperties } from "react";
import { useMemo } from "react";
import "./index.css";
import { clsx } from "clsx";
import { pxToRem } from "../../utils";
import { Text } from "../Text";
import type { IDividerProps } from "./types";

export const Divider = ({
  text,
  direction = "horizontal",
  width,
  height,
  className,
}: IDividerProps) => {
  const rootClass: string = clsx(
    "nuco-divider",
    `nuco-divider--${direction}`,
    text && "nuco-divider--with-text",
    className,
  );

  const style: CSSProperties = useMemo(() => {
    const dimensions: CSSProperties = {};

    if (width !== undefined) {
      dimensions.width = pxToRem(width);
    }

    if (height !== undefined) {
      dimensions.height = pxToRem(height);
    }

    return dimensions;
  }, [width, height]);

  return (
    <div className={rootClass} style={style}>
      {text && <Text className="nuco-divider__text">{text}</Text>}
    </div>
  );
};
